import { useNavigate } from 'react-router-dom';
import { useProducts } from '../../../hooks/useProducts';

export default function FeaturedProducts() {
  const navigate = useNavigate();
  const { products, loading } = useProducts(true, 30000);

  if (loading) {
    return (
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-cyan-600"></div>
          </div>
        </div>
      </section>
    );
  }

  const featuredProducts = products.slice(0, 8);

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4 tracking-tight">
            FEATURED GEAR
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            Trusted by professional anglers worldwide
          </p>
        </div>

        {featuredProducts.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-xl text-gray-600">No products available at the moment</p>
          </div>
        ) : (
          <>
            {/* Products Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-product-shop>
              {featuredProducts.map((product) => (
                <div 
                  key={product.id} 
                  className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
                  onClick={() => navigate(`/product/${product.handle || product.id}`)}
                >
                  {/* Product Image */}
                  <div className="relative overflow-hidden bg-gray-100 aspect-square">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    {product.originalPrice && product.originalPrice > product.price && (
                      <div className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-xs font-bold uppercase">
                        Sale
                      </div>
                    )}
                  </div>

                  {/* Product Info */}
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-cyan-600 transition-colors">
                      {product.name}
                    </h3>
                    
                    {/* Price */}
                    <div className="flex items-center gap-2 mb-4">
                      <span className="text-2xl font-black text-cyan-600">
                        ${product.price.toFixed(2)}
                      </span>
                      {product.originalPrice && product.originalPrice > product.price && (
                        <span className="text-lg text-gray-400 line-through">
                          ${product.originalPrice.toFixed(2)}
                        </span>
                      )}
                    </div>

                    {/* Quick View Button */}
                    <button 
                      className="w-full bg-gray-900 hover:bg-cyan-600 text-white py-3 rounded-md transition-all cursor-pointer whitespace-nowrap font-semibold text-sm uppercase tracking-wider"
                    >
                      Quick View
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* View All Button */}
            <div className="text-center">
              <button 
                onClick={() => navigate('/products')}
                className="bg-cyan-600 hover:bg-cyan-700 text-white px-12 py-5 rounded-md text-lg font-bold transition-all cursor-pointer whitespace-nowrap uppercase tracking-wider shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                View All Products
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
}